import styled from 'styled-components';
import { Col } from 'antd';
import { merriweather } from 'styles/GlobalStyle';

const Content = styled(Col)`
    font-family: ${merriweather.style.fontFamily};
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.72;
    letter-spacing: normal;
    text-align: left;
    color: black;
    clear: both;
    strong {
        font-weight: 700;
    }

    img {
        max-width: 100%;
        height: auto;
    }
`;

export default Content;
